import { Point } from '../../types'
import { BaseHandle } from '../base/baseHandle'
import { MARKER_DEFAULT_FILL_COLOR, MARKER_DEFAULT_STROKE_COLOR } from '../../constants'
import type p5 from 'p5'

class CircleHandle extends BaseHandle {
  size: number
  _strokeWeight: number
  hoveredStrokeWeight: number

  constructor(p: p5, position: Point, size: number, strokeWeight: number) {
    super(p)
    this.position = position
    this.size = size
    this._strokeWeight = strokeWeight
  }

  isMousedOver() {
    const localCoordinates = this.getLocalCoordinates()
    const mouseX = localCoordinates.x
    const mouseY = localCoordinates.y
    const dx = (mouseX - this.position.x) / this.size
    const dy = (mouseY - this.position.y) / this.size
    return dx * dx + dy * dy < 1
  }

  setupStroke() {
    this.p.stroke(MARKER_DEFAULT_STROKE_COLOR)
    this.p.strokeWeight(this.isMousedOver() ? this.hoveredStrokeWeight : this.strokeWeight)
    this.p.fill(MARKER_DEFAULT_FILL_COLOR)
  }

  render() {
    this.setupStroke()
    this.p.ellipse(this.position.x, this.position.y, this.size)
  }

  set strokeWeight(newStrokeWeight: number) {
    this._strokeWeight = newStrokeWeight
    this.hoveredStrokeWeight = this.strokeWeight * 0.5
  }

  get strokeWeight(): number {
    return this._strokeWeight
  }
}

export { CircleHandle }
